import React from 'react';
const Row = ({
  location,
  own,
  accent_color
}) => {
  var _location$all_complai;
  const ACR = (_location$all_complai = location.all_complaints_ratio) !== null && _location$all_complai !== void 0 ? _location$all_complai : null;
  return /*#__PURE__*/React.createElement("div", {
    className: `list-row list-item ${location.ranking === (own === null || own === void 0 ? void 0 : own.ranking) && 'list-item-own'}`,
    style: {
      '--accent-color': accent_color
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "name"
  }, /*#__PURE__*/React.createElement("span", {
    className: "ranking-prefix"
  }, location.ranking, "."), " ", location.name), /*#__PURE__*/React.createElement("div", {
    className: "value"
  }, ACR ? /*#__PURE__*/React.createElement("div", null, ACR) : '-'));
};
export default Row;